/**
 * Extracts the promotion subdomain (e.g. "an211") from a hostname like
 * "an211.gadz.app", given the app's base domain ("gadz.app").
 * Returns null for the base domain itself, "www", or any host that isn't
 * a subdomain of baseDomain (e.g. localhost during development).
 */
export function extractPromsSubdomain(hostname: string, baseDomain: string): string | null {
	const normalizedHost = hostname.trim().toLowerCase();
	const normalizedBase = baseDomain.trim().toLowerCase();

	if (normalizedHost === normalizedBase) return null;

	const suffix = '.' + normalizedBase;
	if (!normalizedHost.endsWith(suffix)) return null;

	const subdomain = normalizedHost.slice(0, -suffix.length);
	if (!subdomain || subdomain === 'www' || subdomain.includes('.')) return null;

	return subdomain;
}

/**
 * Turns a lowercase subdomain-derived promotion (e.g. "an211") into the
 * canonically-cased promotion string used everywhere else in the app and
 * stored on records (e.g. "An211"), by matching its 2-letter campus code
 * against the known campus list. Returns null if it doesn't look like a
 * promotion (wrong shape) or the campus code isn't recognized.
 */
export function canonicalizePromotion(promotion: string, findCampusByCode: (campusCode: string) => { code: string } | null): string | null {
	const match = /^([A-Za-z]{2})(\d{2,3})$/.exec(promotion.trim());
	if (!match) return null;
	const [, campusCode, year] = match;
	const campus = findCampusByCode(campusCode);
	return campus ? campus.code + year : null;
}
